﻿import request from '@/config/axios'

// 绩效考核 VO
export interface PerformanceVO {
  id?: string | number
  shopId: string | number
  employeeId: string | number
  employeeName?: string
  positionName?: string
  period: string
  score: number
  grade: string // A/B/C/D/E
  metrics?: string  // JSON格式的各项指标
  comment?: string
  appraiserId?: string | number
  appraiseTime?: string
  createTime?: Date
}

// 获取绩效考核分页
export const getPerformancePage = (params: any) => {
  return request.get({ url: '/hotel/performance/page', params })
}

// 获取绩效考核详情
export const getPerformance = (id: string | number) => {
  return request.get({ url: '/hotel/performance/get?id=' + id })
}

// 创建绩效考核
export const createPerformance = (data: PerformanceVO) => {
  return request.post({ url: '/hotel/performance/create', data })
}

// 更新绩效考核
export const updatePerformance = (data: PerformanceVO) => {
  return request.put({ url: '/hotel/performance/update', data })
}

// 删除绩效考核
export const deletePerformance = (id: string | number) => {
  return request.delete({ url: '/hotel/performance/delete?id=' + id })
}

// 批量删除绩效考核
export const deletePerformanceList = (ids: (string | number)[]) => {
  return request.delete({ url: '/hotel/performance/delete-list?ids=' + ids.join(',') })
}

// 获取员工简单列表(下拉选择用)
export const getEmployeeListAll = (params?: any) => {
  return request.get({ url: '/hotel/employee/list-all', params })
}